module.exports = [{"title":"BB-8","date":"10/2016","tags":["CSS"],"url":"http://works.baptistevillain.fr/bb-8"},{"title":"Earth Climate","date":"12/2016","tags":["SVG","JS"],"url":"http://works.baptistevillain.fr/temp-evolution/"},{"title":"Asteroid Belt","date":"11/2016","tags":["JS","Canvas"],"url":"http://works.baptistevillain.fr/asteroid-belt/"},{"title":"Space Traveler","date":"12/2016","tags":["JS","SCSS"],"url":"http://works.baptistevillain.fr/space-traveler/"},{"title":"Vintage TV","date":"04/2017","tags":["JS","CSS","Video"],"url":"http://works.baptistevillain.fr/vintage-tv/"}]


//////////////////
// WEBPACK FOOTER
// ./src/json/lab.json
// module id = hDp+
// module chunks = 1